<template>
  <router-link @click="trackClick" to="/12-week-nutrition-program" class="nutrable-program-promo">
    <img
      src="/images/nutrable-program/hero-home.jpg"
      alt="Explore UCARI's 12-week Nutrable nutrition coaching program"
      loading="lazy"
    >
    <span class="nutrable-program-promo__shade" aria-hidden="true"></span>
    <span class="nutrable-program-promo__content">
      <span class="nutrable-program-promo__eyebrow">Nutrition coaching</span>
      <strong>Turn your results into a plan</strong>
      <span>12 weeks of expert food intolerance support</span>
      <span class="nutrable-program-promo__action">Explore the program <span aria-hidden="true">&rarr;</span></span>
    </span>
  </router-link>
</template>

<script>
import { trackPromoClick } from '@/utils/activity';

export default {
  name: 'NutrableProgramPromo',
  props: {
    source: {
      type: String,
      default: null,
      validator: value => ['test-kits', 'test-results'].includes(value),
    },
  },
  methods: {
    trackClick() {
      trackPromoClick('nutrable', this.source);
    },
  },
};
</script>

<style scoped>
.nutrable-program-promo {
  position: relative;
  display: block;
  width: 90%;
  min-height: 330px;
  margin-left: auto;
  overflow: hidden;
  border-radius: 20px;
  background: #07468D;
  box-shadow: 0 10px 24px rgba(15, 38, 95, 0.12);
  color: #fff !important;
}

.nutrable-program-promo img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 58% 50%;
  transition: transform 0.3s ease;
}

.nutrable-program-promo__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(14, 44, 89, 0.08) 12%, rgba(14, 44, 89, 0.92) 100%);
}

.nutrable-program-promo__content {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 25px;
}

.nutrable-program-promo__eyebrow {
  color: #ffd3e6;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.nutrable-program-promo strong {
  color: #fff;
  font-size: 24px;
  line-height: 1.08;
}

.nutrable-program-promo__action {
  margin-top: 8px;
  font-weight: 800;
}

.nutrable-program-promo:hover img {
  transform: scale(1.025);
}

@media (max-width: 639px) {
  .nutrable-program-promo {
    width: 100%;
    min-height: 300px;
    margin-left: 0;
    border-radius: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nutrable-program-promo img {
    transition: none;
  }
}
</style>
